import 'whatwg-fetch';
require('script-loader!.tmp/js/templates/url/url.js');

class IPGeolocationManager {
  constructor() {
    this._urlPath = null;
  }

  getCurrentLocation() {
    return new Promise((resolve, reject) => {
      fetch(`${Yext.BaseUrl}${url.geocodeIp()}`)
        .then((resp) => {
          if (resp.status < 200 || resp.status > 300) {
            reject(resp.status);
            return;
          }
          resp.json().then((data) => {
            resolve(data);
          });
        }).catch(err => reject(err));
    });
  }
}

const DefaultIPGeolocationManager = new IPGeolocationManager();

export {
  IPGeolocationManager,
  DefaultIPGeolocationManager
};